import { FieldInstruction } from 'containers/FormBuilder'
import TextInputField from 'form/fieldComponents/InputField'
import PasswordInputField from 'form/fieldComponents/PasswordIField'
import { FIELD_REQUIRED } from 'form/validation/validationMessages'
import * as Yup from 'yup'

export const username: FieldInstruction<typeof TextInputField> = {
    Component: TextInputField,
    config: {
        label: 'Email Address or Username',
        validator: Yup.string().required(FIELD_REQUIRED),
    },
}

export const password: FieldInstruction<typeof PasswordInputField> = {
    Component: PasswordInputField,
    config: {
        label: 'Password',
        validator: Yup.string().required(FIELD_REQUIRED),
    },
}
